/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './lab-test-item-limit.reducer';

export const LabTestItemLimit = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const labTestItemLimitList = useAppSelector(state => state.labTestItemLimit.entities);
  const loading = useAppSelector(state => state.labTestItemLimit.loading);
  const totalItems = useAppSelector(state => state.labTestItemLimit.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="lab-test-item-limit-heading" data-cy="LabTestItemLimitHeading">
        <Translate contentKey="tinyMedicRestApp.labTestItemLimit.home.title">Lab Test Item Limits</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.labTestItemLimit.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/lab-test-item-limit/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.labTestItemLimit.home.createLabel">Create new Lab Test Item Limit</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.labTestItemLimit.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {labTestItemLimitList && labTestItemLimitList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('unitsOfMeasure')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.unitsOfMeasure">Units Of Measure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('unitsOfMeasure')} />
                </th>
                <th className="hand" onClick={sort('resultType')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.resultType">Result Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('resultType')} />
                </th>
                <th className="hand" onClick={sort('normalRangeLowerLimit')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.normalRangeLowerLimit">Normal Range Lower Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('normalRangeLowerLimit')} />
                </th>
                <th className="hand" onClick={sort('normalRangeUpperLimit')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.normalRangeUpperLimit">Normal Range Upper Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('normalRangeUpperLimit')} />
                </th>
                <th className="hand" onClick={sort('possibleRangeLowerLimit')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.possibleRangeLowerLimit">Possible Range Lower Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('possibleRangeLowerLimit')} />
                </th>
                <th className="hand" onClick={sort('possibleRangeUpperLimit')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.possibleRangeUpperLimit">Possible Range Upper Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('possibleRangeUpperLimit')} />
                </th>
                <th className="hand" onClick={sort('template')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.template">Template</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('template')} />
                </th>
                <th className="hand" onClick={sort('ageMin')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.ageMin">Age Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMin')} />
                </th>
                <th className="hand" onClick={sort('ageMax')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.ageMax">Age Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMax')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('weightMin')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.weightMin">Weight Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMin')} />
                </th>
                <th className="hand" onClick={sort('weightMax')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.weightMax">Weight Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMax')} />
                </th>
                <th className="hand" onClick={sort('bsaMin')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.bsaMin">Bsa Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bsaMin')} />
                </th>
                <th className="hand" onClick={sort('bsaMax')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.bsaMax">Bsa Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bsaMax')} />
                </th>
                <th className="hand" onClick={sort('displayPrecision')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.displayPrecision">Display Precision</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('displayPrecision')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.testItem">Test Item</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemLimit.lab">Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {labTestItemLimitList.map((labTestItemLimit, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/lab-test-item-limit/${labTestItemLimit.id}`} color="link" size="sm">
                      {labTestItemLimit.id}
                    </Button>
                  </td>
                  <td>{labTestItemLimit.active ? 'true' : 'false'}</td>
                  <td>{labTestItemLimit.lastUpdated}</td>
                  <td>{labTestItemLimit.timestampEntry}</td>
                  <td>{labTestItemLimit.microSec}</td>
                  <td>{labTestItemLimit.cursor}</td>
                  <td>{labTestItemLimit.unitsOfMeasure}</td>
                  <td>{labTestItemLimit.resultType}</td>
                  <td>{labTestItemLimit.normalRangeLowerLimit}</td>
                  <td>{labTestItemLimit.normalRangeUpperLimit}</td>
                  <td>{labTestItemLimit.possibleRangeLowerLimit}</td>
                  <td>{labTestItemLimit.possibleRangeUpperLimit}</td>
                  <td>{labTestItemLimit.template}</td>
                  <td>{labTestItemLimit.ageMin}</td>
                  <td>{labTestItemLimit.ageMax}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Gender.${labTestItemLimit.gender}`} />
                  </td>
                  <td>{labTestItemLimit.weightMin}</td>
                  <td>{labTestItemLimit.weightMax}</td>
                  <td>{labTestItemLimit.bsaMin}</td>
                  <td>{labTestItemLimit.bsaMax}</td>
                  <td>{labTestItemLimit.displayPrecision ? 'true' : 'false'}</td>
                  <td>
                    {labTestItemLimit.testItem ? (
                      <Link to={`/lab-test-item/${labTestItemLimit.testItem.id}`}>{labTestItemLimit.testItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{labTestItemLimit.lab ? <Link to={`/diag-lab/${labTestItemLimit.lab.id}`}>{labTestItemLimit.lab.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/lab-test-item-limit/${labTestItemLimit.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/lab-test-item-limit/${labTestItemLimit.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/lab-test-item-limit/${labTestItemLimit.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.home.notFound">No Lab Test Item Limits found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={labTestItemLimitList && labTestItemLimitList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default LabTestItemLimit;
